import API from '../../utils/api';
import LocalStorageService from '../localStorage';
import {
  EndpointTypeOption,
  FetchScriptsParams,
  Script,
  ScriptRunPayload,
} from '../../pages/scripts/types';
import { BaseResponse } from '../types';
import { ScriptTestResponse } from './types';

const localStorageService = (LocalStorageService as any).getService();

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorageService.getAccessToken()}`,
  },
});

const basePath = (orgId: string) =>
  `transformations/transformations/${encodeURIComponent(orgId)}`;

export const fetchScripts = (
  orgId: string,
  params: FetchScriptsParams = {},
) => {
  const {
    pageNumber = 1,
    pageSize = 10,
    orderBy,
    orderByDesc,
    search,
    endpointTypeId,
    endpointSubtypeId,
    inputTypeId,
  } = params;

  const query = new URLSearchParams();
  query.set('pageNumber', String(pageNumber));
  query.set('pageSize', String(pageSize));
  if (orderBy) query.set('orderBy', orderBy);
  if (orderByDesc !== undefined) query.set('orderByDesc', String(orderByDesc));
  if (search) query.set('search', search);
  if (endpointTypeId) query.set('endpointTypeId', String(endpointTypeId));
  if (endpointSubtypeId)
    query.set('endpointSubtypeId', String(endpointSubtypeId));
  if (inputTypeId) query.set('inputTypeId', String(inputTypeId));

  return API.get(`${basePath(orgId)}?${query.toString()}`, authHeaders());
};

export const fetchScriptById = (orgId: string, id: string) => {
  return API.get(`${basePath(orgId)}/${encodeURIComponent(id)}`, authHeaders());
};

export const createScript = (
  orgId: string,
  data: Omit<Script, 'id' | 'lastModifiedDate'>,
) => {
  return API.post(basePath(orgId), data, authHeaders());
};

export const updateScript = (
  orgId: string,
  id: string,
  data: Omit<Script, 'lastModifiedDate'>,
) => {
  return API.put(
    `${basePath(orgId)}/${encodeURIComponent(id)}`,
    data,
    authHeaders(),
  );
};

export const deleteScript = (orgId: string, id: string) => {
  return API.delete(
    `${basePath(orgId)}/${encodeURIComponent(id)}`,
    authHeaders(),
  );
};

export const testScript = (
  orgId: string,
  id: string,
  payload: ScriptRunPayload,
) => {
  return API.post<BaseResponse<ScriptTestResponse>>(
    `${basePath(orgId)}/${encodeURIComponent(id)}/test`,
    payload,
    authHeaders(),
  );
};

export const deployScript = (orgId: string, id: string) => {
  return API.post(
    `${basePath(orgId)}/${encodeURIComponent(id)}/deploy`,
    {},
    authHeaders(),
  );
};

export const fetchScriptTypes = () => {
  return API.get<BaseResponse<EndpointTypeOption[]>>(
    'transformations/transformations/types',
    authHeaders(),
  );
};
